import { render, staticRenderFns } from "./PageContentHeader.vue?vue&type=template&id=73ecc29f&"
import script from "./PageContentHeader.vue?vue&type=script&lang=js&"
export * from "./PageContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports